import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

const redirectMEP = () => {
  const query = new URLSearchParams(document.location.search);
  console.log(process.env.REACT_APP_REDIRECT_MEP);
  if(query.get('token')){
    return <App />
  } else {
    window.location.replace(process.env.REACT_APP_REDIRECT_MEP);
  }
}

root.render(
  <React.StrictMode>
    {redirectMEP()}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
